import _ from 'lodash';
import { AnyAction } from 'redux';
import IApplicationEmail from '~Api/ApplicationEmail/IApplicationEmail';
import { IDictionary } from '~utilities/IDictionary';
import {
    IApplicationEmailTextSetAction,
    IApplicationEmailsListAction,
    IApplicationEmailsSetAction,
} from './actions';
import ApplicationEmailsActionsEnum from './ActionsEnum';

export interface IApplicationEmailsState {
    emails: IDictionary<IApplicationEmail>;
    pageCounts: IDictionary<number>;
    pageEmailUuids: IDictionary<string[]>;
    pageNumbers: IDictionary<number>;
    texts: IDictionary<string>;
}

const initialData: IApplicationEmailsState = {
    emails: {},
    pageCounts: {},
    pageEmailUuids: {},
    pageNumbers: {},
    texts: {},
};

export function applicationEmailsReducer(state: IApplicationEmailsState = initialData, action: AnyAction): IApplicationEmailsState {
    switch (action.type) {
        case ApplicationEmailsActionsEnum.ApplicationEmailsList: {
            const typedAction: IApplicationEmailsListAction = action as IApplicationEmailsListAction;

            return {
                ...state,
                pageEmailUuids: {
                    ...state.pageEmailUuids,
                    [typedAction.applicationUuid]: null,
                },
                pageNumbers: {
                    ...state.pageNumbers,
                    [typedAction.applicationUuid]: typedAction.pageNumber,
                },
            };
        }

        case ApplicationEmailsActionsEnum.ApplicationEmailsSet: {
            const typedAction: IApplicationEmailsSetAction = action as IApplicationEmailsSetAction;

            return {
                ...state,
                emails: {
                    ...state.emails,
                    ..._.keyBy(typedAction.emails, 'uuid'),
                },
                pageCounts: {
                    ...state.pageCounts,
                    [typedAction.applicationUuid]: typedAction.count,
                },
                pageEmailUuids: {
                    ...state.pageEmailUuids,
                    [typedAction.applicationUuid]: _.map(typedAction.emails, (email: IApplicationEmail): string => email.uuid),
                },
            };
        }

        case ApplicationEmailsActionsEnum.ApplicationEmailTextSet: {
            const typedAction: IApplicationEmailTextSetAction = action as IApplicationEmailTextSetAction;

            return {
                ...state,
                texts: {
                    ...state.texts,
                    [typedAction.applicationEmailUuid]: typedAction.text,
                },
            };
        }

        default:
            return state;
    }
}
